module.exports = __webpack_public_path__ + "media/bootstrap-icons/cone-3b98fa73.svg";